module.exports = require("@wildboar/x500/src/lib/modules/DirectoryIDMProtocols/dop-ip.oa");